import { render, staticRenderFns } from "./CustomerActivityCard.vue?vue&type=template&id=ee634176&scoped=true"
import script from "./CustomerActivityCard.vue?vue&type=script&lang=js"
export * from "./CustomerActivityCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerActivityCard.vue?vue&type=style&index=0&id=ee634176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee634176",
  null
  
)

export default component.exports